export default "__VITE_ASSET__d5ae4c9c__"